/**
 * Load the AdSense bootstrap after first paint so Auto ads do not compete
 * with LCP or shift the first viewport. Call once from the client layout.
 */
let injected = false;

export function loadAdSense(): void {
  if (injected || typeof document === 'undefined') return;
  const publisherId = process.env.GATSBY_ADSENSE_PUBLISHER_ID;
  if (!publisherId) return;
  if (document.querySelector('script[data-tvroulette-adsense]')) {
    injected = true;
    return;
  }

  injected = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;
  script.crossOrigin = 'anonymous';
  script.dataset.tvrouletteAdsense = 'true';
  document.head.appendChild(script);
}

export function resetAdSenseLoaderForTests(): void {
  injected = false;
}
